import { FC, ReactNode } from 'react'

import { Footer } from './footer'
// import { Header } from './header'

export type LayoutProps = {
  children: ReactNode
}

export const Layout: FC<LayoutProps> = ({ children }) => (
  <>
    {/* <Header
      onTop={headerOnTop}
      isTransparent={hasTransparentHeader}
      inverted={invertedHeader}
    /> */}
    {children}
    <Footer />
  </>
)
